import React, { useState, useRef, useEffect } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { MSpinner, MDropzone } from 'components/Shared';
import FilePreview from './FilePreview';
import useDeleteAttachments from './utility/useDeleteAttachments';
import { getAttachments, regeneratePdf, addAttachmentRequest } from 'requests/homeowner/caseforms';
import { MCard } from '../../../../components/Shared';
import responseHandler from "responseHandler";

const FileManager = ({
  controlNumber,
  dispatch,
  onPreview,
  canRegeneratePdf,
  makeToast
}) => {
  const [files, setFiles] = useState([]);
  const [initialFileFetch, setInitialFileFetch] = useState(false);
  const [isRegenerating, setIsRegenerating] = useState(false);
  const [deleteAttachments] = useDeleteAttachments({ controlNumber, dispatch, callback: payload => setFiles(payload) });
  const [previewFile, setPreviewFile] = useState(null);

  let mounted = useRef(true);

  const fetchFiles = () => {
    getAttachments(
      controlNumber,
      payload => {
        setFiles(payload);
        setInitialFileFetch(true);
        setIsRegenerating(false);
      },
      mounted
    );
  };


  const addAttachments = files => {
    const filteredFiles = files.filter(({ file }) => file);
    if (filteredFiles.length !== 0)
      filteredFiles.map(({ file }) => {
        addAttachmentRequest(
          controlNumber,
          file,
          fetchFiles,
          mounted
        );
      });
  };

  useEffect(
    () => {
      fetchFiles();
      return () => mounted.current = false;
    },
    []
  );

  let cardActions =
      previewFile
          ? [{
            icon: "close",
            helpText: "Close Preview",
            onClick: () => setPreviewFile(null)
          }]
          : canRegeneratePdf
              ? [{
                icon: "loop",
                buttonText: isRegenerating
                    ? "Regenerating PDF..."
                    : "Regenerate PDF",
                helpText: "Regenerate PDF",
                onClick: () => {
                  setIsRegenerating(true);

                  regeneratePdf(
                      controlNumber,
                      (response) => {

                        if (!response?.success) {

                          // IT Errors
                          if (response?.itErrors) {
                            makeToast(response.itErrors, "error");
                          }

                          // QA Errors
                          else if (response?.qaErrors) {
                            makeToast(response.qaErrors, "warning");
                          }

                          // fallback
                          else {
                            makeToast("PDF regeneration failed.", "error");
                          }

                          setIsRegenerating(false);
                          return;
                        }

                        fetchFiles();
                      },
                      mounted
                  );
                },
                disabled: isRegenerating,
                className: isRegenerating
                    ? "rotate-regenerate-pdf-icon"
                    : ""
              }]
              : [];


  return initialFileFetch ?
    (<MCard
      title="Case File Manager"
      className="full-height-card file-manager"
      actions={cardActions}>
      {previewFile ?
        <FilePreview
          displayname={previewFile.name}
          path={previewFile.url}
        /> :
        <MDropzone
          existingFiles={files && files.attachedFiles}
          multiple
          noClick
          onPreview={(file, urlWithSSO) => onPreview ? onPreview(file, urlWithSSO) : setPreviewFile({ name: file.name, url: urlWithSSO })}
          onFileAdd={addAttachments}
          onFileRemove={deleteAttachments}
          prompt="No Files on Case"
        />}
    </MCard>) :
    <MSpinner />;
};

FileManager.propTypes = {
  controlNumber: PropTypes.number,
  dispatch: PropTypes.func,
  onPreview: PropTypes.func, //if provided it will override the default file manager preview, called with the file object, and the preview url with sso added
  canRegeneratePdf: PropTypes.bool,
  makeToast: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
  dispatch
});

export default connect(null,mapDispatchToProps)(FileManager);
